
import React from 'react';
import { motion } from 'motion/react';
import { SimulationConfig, SimulationMode } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';

interface ModeSelectorSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const ModeSelectorSection: React.FC<ModeSelectorSectionProps> = ({ config, setConfig }) => {
  const modes: SimulationMode[] = ['SPAWNER', 'DRAWER', 'TRAIL', 'ESCAPE', 'RHYTHMIC', 'SPACE_SPIRAL', 'RHYTHMIC_ESCAPE'];
  
  return (
    <>
      <SectionLabel icon="fa-cube" darkMode={config.darkMode}>Logic Engine</SectionLabel>
      <div className={`grid grid-cols-3 gap-1.5 p-1.5 w-full rounded-2xl mb-4 ${config.darkMode ? 'bg-black/30 border border-white/5' : 'bg-neutral-100'}`}>
        {modes.map(m => (
          <button 
            key={m} 
            onClick={() => setConfig(prev => ({ ...prev, mode: m }))} 
            className={`text-[10px] font-bold uppercase py-3 rounded-xl transition-all relative overflow-hidden ${config.mode === m ? (config.darkMode ? 'text-white' : 'text-zinc-900') : 'text-zinc-500'}`}
          >
            {config.mode === m && (
              <motion.div 
                layoutId="activeMode" 
                className={`absolute inset-0 z-0 ${config.darkMode ? 'bg-white/10' : 'bg-white shadow-sm'}`} 
              />
            )}
            <span className="relative z-10">{m.replace('_', ' ')}</span>
          </button>
        ))}
      </div>
      {config.mode !== 'RHYTHMIC' && (
          <SmartInput label="Container Radius" min={50} max={600} value={config.containerRadius} onChange={v => setConfig(p => ({...p, containerRadius: v}))} darkMode={config.darkMode} />
      )}
    </>
  );
};
